// @flow
import React from "react";
import PropTypes from "prop-types";
import styles from "./Timer.scss";

class Timer extends React.Component {
  state = {
    days: null,
    hours: null,
    minutes: null,
    seconds: null,
    remainingTime: null,
    overflow: false
  };

  componentDidMount = () => {
    this.interval = setInterval(this.timer, 1000);
  };

  componentWillUnmount = () => {
    if (this.interval) {
      clearInterval(this.interval);
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.hours !== prevState.hours && this.props.timerValue) {
      this.props.timerValue(
        (Number(this.state.days) * 24) + Number(this.state.hours)
      );
    }
  };

  timer = () => {
    const { endDate } = this.props;
    const countDownDate = new Date(endDate).getTime();
    const now = new Date().getTime();
    const distance = Math.abs(countDownDate - now);
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // if (distance < 0) {
    //   if (this.interval) {
    //     clearInterval(this.interval);
    //   }
    //   this.setState({
    //     days: 0,
    //     hours: 0,
    //     minutes: 0,
    //     seconds: 0
    //   });
    // } else {
    this.setState({
      days,
      hours,
      minutes,
      seconds,
      overflow: countDownDate < now
    });
    // }
  };

  prefix = n => {
    return ("0" + n).slice(-2);
  };

  render() {
    const { days, hours, minutes, seconds, overflow } = this.state;
    return (
      <div className={`${styles.timer} ${overflow ? styles.overflow : ""}`}>
        {overflow ? <span> - </span> : ""}
        {days ? <span>{this.prefix(days)} :</span> : ""}
        <span>{this.prefix(hours || 0)}</span> :
        <span>{this.prefix(minutes || 0)}</span> :
        <span>{this.prefix(seconds || 0)}</span>
      </div>
    );
  }
}

export default Timer;



// WEBPACK FOOTER //
// ./src/components/common/timer/Timer.js